export const sendAnalyticEvent = (goal:string):void => {
  if (window.Ya && window.Ya._metrika) {
    Object.keys(window.Ya._metrika.counters || {}).forEach(c => {
      window.Ya._metrika.counters[c].reachGoal(goal);
    });
  }
};